import ToastManager from './toast.manager';

class Toast {
  static manager = null;

  static error(props) {
    return Toast.getManager().error(props);
  }

  static success(props) {
    return Toast.getManager().success(props);
  }

  static warning(props) {
    return Toast.getManager().warning(props);
  }

  static info(props) {
    return Toast.getManager().info(props);
  }

  static close(key) {
    Toast.getManager().close(key);
  }

  static closeAll() {
    Toast.getManager().closeAll();
  }

  static getDuplicationKey(props) {
    return Toast.getManager().getDuplicationKey(props);
  }

  static isDuplicated(props) {
    return !!Toast.getDuplicationKey(props);
  }

  static destroy() {
    Toast.getManager().destroy();
  }

  static setTemplate(template) {
    Toast.getManager().setTemplate(template);
  }

  static getManager() {
    if (!Toast.manager) {
      Toast.manager = new ToastManager();
    }
    return Toast.manager;
  }
}

export default Toast;
